// Create by @Amit Sharma, dont delete this file need for Ckeditor fileList

import html2canvas from 'html2canvas';

const GenerateThumbnail = async content => {
  const container = document.createElement('div');
  container.style.width = '210mm'; // Set the width to match A4 width (210mm)
  container.style.height = '297mm'; // Set the height to match A4 height (297mm)
  container.style.overflow = 'hidden';

  const element = document.createElement('div');
  element.innerHTML = content;

  container?.appendChild(element);
  const parent = document.querySelector('.template-container');

  const tempDiv = document.createElement('div');
  tempDiv.style.width = 0;
  tempDiv.style.height = 0;

  tempDiv.appendChild(container);
  if (parent) {
    parent.appendChild(tempDiv);
  } else {
    document.body.appendChild(container);
  }
  // creating dummy element on the body so that it doesnt apprear on the screen

  try {
    const canvas = await html2canvas(element, {
      width: 210 * 2.83, // Set canvas width to match A4 width in pixels (1mm = 2.83px approximately)
      height: 297 * 2.83, // Set canvas height to match A4 height in pixels
      useCORS: true // Set this option to true to handle CORS images
    }); // Convert the canvas to a data URL

    const thumbnailDataUrl = canvas.toDataURL('image/png'); // Clean up the container
    if (parent) {
      parent.removeChild(tempDiv);
    } else {
      document.body.removeChild(container);
    }

    return thumbnailDataUrl;
  } catch (error) {
    // console.error("Error generating thumbnail:", error);
    // Clean up the container in case of an error
    if (parent) {
      parent.removeChild(tempDiv);
    } else {
      document.body.removeChild(container);
    }
    return null;
  }
};

export default GenerateThumbnail;
